import React from 'react';
import {
  Box,
  Paper,
  Text,
  ThemeIcon,
  useMantineTheme,
  useComputedColorScheme,
} from '@mantine/core';
import { IconNotes } from '@tabler/icons-react';

interface InternalCommentProps {
  comment: string;
}

export const InternalComment: React.FC<InternalCommentProps> = ({
  comment,
}) => {
  const theme = useMantineTheme();
  const scheme = useComputedColorScheme('dark');
  const cardBg =
    scheme === 'dark' ? theme.colors.dark[6] : theme.colors.gray[0];
  const border =
    scheme === 'dark' ? theme.colors.dark[4] : theme.colors.gray[3];

  return (
    <Paper
      withBorder
      radius="md"
      p="sm"
      mb="xs"
      data-testid="internal-comment"
      style={{ background: cardBg, borderColor: border }}
    >
      <Box mb="xs" style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        <ThemeIcon
          variant="light"
          size="sm"
          data-testid="internal-comment-icon"
        >
          <IconNotes size={14} />
        </ThemeIcon>
        <Text fw={600} data-testid="internal-comment-heading">
          Internal Comment
        </Text>
      </Box>
      <Text fs="italic" ml="md" data-testid="internal-comment-text">
        {comment}
      </Text>
    </Paper>
  );
};
